import getConfig from "next/config"

export function env(key: string) {
  if (typeof window !== "undefined") {
    if (location.hostname) {
      const { environments } = getConfig().publicRuntimeConfig
      return (environments[location.hostname] || {})[key]
    }
  }
  return ""
}
